@if (items) {
  @for (item of items; track item; let even = $even) {
    <div class="offer-details">
      <div [ngClass]="even ? 'row-even' : 'row-odd'">
        <div class="offer-details__vehicle">
          <span class="offer-details__vehicle-title" [ngClass]="even ? 'row-even' : 'row-odd'">{{ getVehicleTitle(item)
          }}</span>
        </div>
        <div class="latest-offer">
          <div class="offer-details__item">
            <div class="offer-details__item-label">{{ CONSTANTS.textVIN }}</div>
            <div class="offer-details__item-value">{{ item.vin }}</div>
          </div>
          <div class="offer-details__item">
            <div class="offer-details__item-label">{{ CONSTANTS.textDate }}</div>
            <div class="offer-details__item-value">{{ formatDate(item.offerHistory.offer.offerDate) }}</div>
          </div>
          <div class="offer-details__item">
            <div class="offer-details__item-label">{{ offerLabel }}</div>
            <div class="offer-details__item-value">{{ formatCurrency(item.offerHistory.offer.amount, false) }}</div>
          </div>
          <div class="offer-details__item">
            <div class="offer-details__item-label">{{ CONSTANTS.textStatus }}</div>
            <div class="offer-details__item-value">{{ item.offerHistory.offer.status | offerStatus }}</div>
          </div>
        </div>
        @if (showSpareKey()) {
          <div class="material-checkbox spare-key-option">
            <mat-checkbox
              [id]="'multi-offer-spare-key-checkbox_' + item.auctionItemUuid"
              [checked]="item.hasSpareKey && !!spareKeySelections()[item.auctionItemUuid]"
              [disabled]="!item.hasSpareKey"
              [disableRipple]="true"
              (change)="spareKeyChange.emit({ auctionItemUuid: item.auctionItemUuid, selected: $event.checked })"
              [attr.data-testid]="'multi-offer-history-spare-key-checkbox-' + item.auctionItemUuid">
              <span>
                {{ CONSTANTS.textAddSpareKeyFor }}
                <strong>{{ formatCurrency(platformSpareKeyFee(), false) }}</strong>
                {{ CONSTANTS.textSentToBuyingDealership }}
              </span>
            </mat-checkbox>
          </div>
        }
        <div>
          <app-collapsable-offer-history class="offer-history-offers" [previousOffers]="item.offerHistory.previousOffers"
          [title]="CONSTANTS.labelViewHistory"></app-collapsable-offer-history>
        </div>
      </div>
    </div>
  }
}